import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgDoubleChecklistIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 14">
      <path d="M18 2.00003L16.59 0.590027L10.25 6.93003L11.66 8.34003L18 2.00003ZM22.24 0.590027L11.66 11.17L7.47997 7.00003L6.06997 8.41003L11.66 14L23.66 2.00003L22.24 0.590027ZM0.409973 8.41003L5.99997 14L7.40997 12.59L1.82997 7.00003L0.409973 8.41003Z" fill="currentColor"/>
    </SvgIcon>
  );
};

export default SvgDoubleChecklistIcon;
